import { Action, createAction, props } from "@ngrx/store";

interface Church {
  name: string;
  slug: string;
  location: string;
  address: string;
  lat: string;
  long: string;

  profile: string;
  created_at: string;
  updated_at: string;
  details: {
    phone: [];
    email: [];
    pastors: [];
    social: [];
  };
  sms_units: string;
  subscription: Subscription;
}

export interface Subscription {
  code: string;
  created_at: string;
  updated_at: string;
  status: string;

  plan: {
    name: string;
    interval: string;
    code: string;
    amount: string;
  };
}

export interface adminProfileDetails {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  memberships: Array<any>;
  details: {
    personal: any;
    membership: any;
    service: any;
    other: any;
    convert: any;
  };
}

export interface initialActions {
  welcome_closed: Boolean;
  popups_closed: Boolean;
  actionItems: {
    regular_members: {
      action_text: string;
      url: string;
      data: Array<any>;
    };
    department: {
      action_text: string;
      url: string;
      data: Array<any>;
    };
    giving_account: {
      action_text: string;
      url: string;
      data: Array<any>;
    };
    house_fellowship: {
      action_text: string;
      url: string;
      data: Array<any>;
    };
    events: {
      action_text: string;
      url: string;
      data: Array<any>;
    };
  };
}

//    membership: { profile: string };

// export enum ActionTypes {
//   loadProfile = "{adminProfileDetails} Load Profile Details",
//   loadSuccess = "{adminProfileDetails} Load success",

//   updateProfile = "{adminProfileDetails} Update Profile Details",
// }

export const updateAdminProfile = createAction(
  "{adminUpdateProfile} Update Profile Details",
  props<{ details: adminProfileDetails }>()
);

export const getAdminProfile = createAction(
  "{adminGetProfile} Get Profile Details"
);

export const getInitialActions = createAction(
  "{adminGetinitialActions} Get initial action details"
);

export const updateInitialActions = createAction(
  "{adminUpdateinitialActions} Update Data in initial actions",
  props<{ info: initialActions }>()
);
// export class updateProfile implements Action {
//  public  type = ActionTypes.updateProfile;
//   constructor(public payload: adminProfileDetails) {}
// }
// export class loadProfile implements Action {
//  public readonly type = ActionTypes.loadProfile;
// }

// export class loadSuccess implements Action {
//   readonly type = ActionTypes.loadSuccess;
//   constructor(public payload: adminProfileDetails) {}
// }

// export type ProfileActions = updateProfile | loadProfile | loadSuccess;

// interface adminChurchDetails {

// }

// {"id":4,"first_name":"Cynthia","last_name":"Akinade","email":"olucynakin@gmail.com","email_verified_at":"2021-01-29T14:58:17.000000Z","phone":null,"is_active":"1","memberships":[{"id":3,"role":"admin","church":{"name":"Cynthia's Church","slug":"cynthias-church","location":"Lagos","address":"Ikoyi","lat":"8.8940691","long":"7.1860402"},"details":{"membership":{},"service":{},"other":{},"convert":null}}],"details":{"personal":{}}}
